import React from "react";
import Select from "react-select";

export default function Pagination({ totalRows, dataPerPage, setDataPerPage, currentPage, setCurrentPage }) {
  const totalPages = Math.ceil(totalRows / dataPerPage);

  const pageSizeOptions = [
    { value: 10, label: "10 rows" },
    { value: 20, label: "20 rows" },
    { value: 50, label: "50 rows" },
    { value: 100, label: "100 rows" },
  ];

  return (
    <>
      <div className="rounded-t mb-0 px-4 py-3 bg-blueGray-50 border-blueGray-100">
        <div className="flex flex-wrap items-center border-0">
          <div className="relative px-4 max-w-full flex-grow flex-1 border-0">
            {totalRows === 0 ? null : (
              <Select
                className="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                menuPlacement="top"
                options={pageSizeOptions}
                value={pageSizeOptions.find((option) => option.value === dataPerPage)}
                onChange={(selectedOption) => {
                  setDataPerPage(selectedOption.value);
                  setCurrentPage(0);
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: 150,
                    zIndex: 9999,
                  }),
                }}
              />
            )}
          </div>
          <div className="relative px-4 max-w-full flex-grow flex-1">
            {totalRows <= dataPerPage ? null : (
              <nav className="block">
                <ul className="flex pl-0 rounded list-none flex-wrap">
                  {[...Array(totalPages).keys()].map((page) => (
                    <li key={page}>
                      <a
                        href="#pablo"
                        className={
                          currentPage === page
                            ? "first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative border-0 text-white bg-lightBlue-500 mr-2"
                            : "first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative border-0 bg-white text-lightBlue-500 mr-2 shadow"
                        }
                        onClick={() => setCurrentPage(page)}
                      >
                        {page + 1}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            )}
          </div>
          <div className="text-left"><p>{totalRows === 1 ? `${totalRows} Record`: `${totalRows} Records`}</p></div>
        </div>
      </div>
    </>
  );
}
